let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hshW4")).then(() => parcelRequire('9g2nt'));